import React from "react";
import "./style.css";

type Props = {
  padding?: string;
  className?: string;
  style?: { [key: string]: string | number };
  children: React.ReactNode;
  id?: string;
};

function Card(props: Props) {
  return (
    <div
      id={props.id}
      className={`card ${props.className || ""}`}
      style={{
        boxSizing: "border-box",
        ...(props.style || {}),
        padding: props.padding || "16px 24px",
      }}
    >
      {props.children}
    </div>
  );
}

export default Card;
